<template>
  <div class="widget-card-header" :class="{'warning': isWarningType}">
    <template v-if="isWarningType">
      <div class="warning-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
    </template>
    <div class="triangle"></div>

    <img v-if="iconName" class="icon" :src="getIconPath()" alt="Icon">
  </div>
</template>

<script>
export default {
  name: 'WidgetCardHeader',
  props: {
    isWarningType: Boolean,
    iconName: String,
  },
  methods: {
    getIconPath() {
      const context = require.context('@/assets/img/icons', false, /.svg$/);
      return context(`./${this.iconName}.svg`);
    },
  },
};
</script>

<style lang="stylus" scoped>
.widget-card-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  &.warning {
    & .triangle {
      display: none;
      @media (max-width 480px) {
        display: block;
      }
    }
  }
}

.widget-card-header .triangle {
  width: 30px;
  height: 30px;
  background: linear-gradient(-80deg, #68BA62, #1C418C);
  position: relative;
  @media (max-width 1170px) {
    width: 28px;
    height: 28px;
  }
  @media (max-width 480px) {
    width: 24px;
    height: 24px;
  }
  &:after {
    width: 31px;
    height: 31px;
    background: linear-gradient(-45deg, white 50%, transparent 50%);
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    content: '';
    @media (max-width 1170px) {
      width: 29px;
      height: 29px;
    }
    @media (max-width 480px) {
      width: 25px;
      height: 25px;
    }
  }
}

.widget-card-header .warning-icon {
  display: flex;
  font-size: 38px;
  color: #DE4B4B;
  @media (max-width 1170px) {
    font-size: 37px;
  }
  @media (max-width 480px) {
    display: none;
  }
}

.widget-card-header .icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
  object-position: top;
  @media (max-width 768px) {
    height: 40px;
    width: 40px;
  }
}
</style>
